import { productos } from "../data/productos";
import CardProducto from "../components/CardProducto";

const Productos = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 p-6">
    {productos.map((item) => (
      <CardProducto key={item.id} {...item} />
    ))}
  </div>
);

export default Productos;
